// Stripe gives an amount in the smallest unit of the currency, and that unit
// is not always 1/100. A copy of frontend/src/services/currency/minor-units.ts
// and backend/utils/currency.py: keep the three tables the same.

const ZERO_DECIMAL: ReadonlySet<string> = new Set([
  'bif',
  'clp',
  'djf',
  'gnf',
  'jpy',
  'kmf',
  'krw',
  'mga',
  'pyg',
  'rwf',
  'ugx',
  'vnd',
  'vuv',
  'xaf',
  'xof',
  'xpf',
]);
const THREE_DECIMAL: ReadonlySet<string> = new Set([
  'bhd',
  'jod',
  'kwd',
  'omr',
  'tnd',
]);

export function minorUnitExponent(currency: string | null | undefined): number {
  const code = (currency || 'eur').toLowerCase();
  if (ZERO_DECIMAL.has(code)) return 0;
  if (THREE_DECIMAL.has(code)) return 3;
  return 2;
}

// The rule of to_minor_units in backend/utils/currency.py. Stripe charges a
// three-decimal currency to two decimals, thus the amount is a multiple of 10.
export function toMinorUnits(
  majorAmount: number,
  currency: string | null | undefined
): number {
  const exponent = minorUnitExponent(currency);
  if (exponent === 3) return Math.round(majorAmount * 100) * 10;
  return Math.round(majorAmount * 10 ** exponent);
}
